import * as angular from "angular";
import * as _ from "lodash";
import {ScheduleService} from "./services/schedule-service.service";

angular
  .module('bringoz.admin.schedule')
  .config(ScheduleConfig);


/* @ngInject */
function ScheduleConfig($stateProvider) {

  $stateProvider

    .state('schedule', {
      parent: 'bringoz.site',
      url: '/schedule',
      template: '<ui-view></ui-view>',

    })

    .state('schedule.templates', {
      url: '/templates?:templateId',
      template: '<schedule-templates-view templates="vm.templates" selected-template="vm.selectedTemplate"></schedule-templates-view>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, $stateParams, $state, templates, site) {

        this.templates = templates;
        let selectedTemplate;

        if ($stateParams.templateId) {
          selectedTemplate = _.find(templates, function (t) {
            return t.id === $stateParams.templateId;
          });
        } else {
          selectedTemplate = _.get(templates, '[0]');
          $state.go('.', {templateId: _.get(selectedTemplate, 'id')}, {
            notify: false,
            reload: false,
            location: 'replace'
          })
        }

        this.selectedTemplate = selectedTemplate;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Schedule Templates"});
        triBreadcrumbsService.addCrumb({name: "Operations Management"});
        triBreadcrumbsService.addCrumb({name: "Administration"});
      },
      resolve: {
        templates: function (scheduleService: ScheduleService, site) {
          return scheduleService.getAllTemplates();
        }
      }

    })

}
